/* LogisticElements.tsx
    Une page affichant la gestion des éléments logistiques
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les éléments
    Utilise l'API correspondante pour les opérations de données
*/

import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { LogisticElementsCrudCard } from 'features/logisticElements/components/LogisticElementsCrudCard';
import PageHeader from 'layout/PageHeader';

export const LogisticElements = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faClipboardList}
			title="Éléments logistiques"
			subtitle="Gérez les éléments logistiques de vos clients"
		/>
		<LogisticElementsCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);
